"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _AVNURAH2cjs = require('./AVNURAH2.cjs');


var _ZQYY7DF3cjs = require('./ZQYY7DF3.cjs');


var _QWIBF3KBcjs = require('./QWIBF3KB.cjs');



var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');





var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');





var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/select/select-item.tsx
var _dom = require('@ariakit/core/utils/dom');
var _events = require('@ariakit/core/utils/events');
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
function isSelected(storeValue, itemValue) {
  if (itemValue == null) return;
  if (storeValue == null) return false;
  if (Array.isArray(storeValue)) {
    return storeValue.includes(itemValue);
  }
  return storeValue === itemValue;
}
var useSelectItem = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useSelectItem2({
    store,
    value,
    getItem: getItemProp,
    hideOnClick,
    setValueOnClick = value != null,
    preventScrollOnKeyDown = true,
    focusOnHover = true,
    ...props
  }) {
    var _a;
    const context = _AVNURAH2cjs.useSelectScopedContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "SelectItem must be wrapped in a SelectList or SelectPopover component."
    );
    const id = _3BSDKDKDcjs.useId.call(void 0, props.id);
    const disabled = _misc.disabledFromProps.call(void 0, props);
    const { listElement, multiSelectable, selected, autoFocus } = _FH6HQ5JNcjs.useStoreStateObject.call(void 0, store, {
      listElement: "listElement",
      multiSelectable(state) {
        return Array.isArray(state.value);
      },
      selected(state) {
        return isSelected(state.value, value);
      },
      autoFocus(state) {
        if (value == null) return false;
        if (state.value == null) return false;
        if (state.activeId !== id && (store == null ? void 0 : store.item(state.activeId))) {
          return false;
        }
        if (Array.isArray(state.value)) {
          return state.value[state.value.length - 1] === value;
        }
        return state.value === value;
      }
    });
    const virtualFocus = _FH6HQ5JNcjs.useStoreState.call(void 0, store == null ? void 0 : store.combobox, "virtualFocus");
    const getItem = _react.useCallback.call(void 0, 
      (item) => {
        const nextItem = {
          ...item,
          value: disabled ? void 0 : value
        };
        if (getItemProp) {
          return getItemProp(nextItem);
        }
        return nextItem;
      },
      [disabled, value, getItemProp]
    );
    hideOnClick = hideOnClick != null ? hideOnClick : value != null && !multiSelectable;
    const onClickProp = props.onClick;
    const setValueOnClickProp = _3BSDKDKDcjs.useBooleanEvent.call(void 0, setValueOnClick);
    const hideOnClickProp = _3BSDKDKDcjs.useBooleanEvent.call(void 0, hideOnClick);
    const onClick = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented) return;
      if (_events.isDownloading.call(void 0, event)) return;
      if (_events.isOpeningInNewTab.call(void 0, event)) return;
      if (setValueOnClickProp(event) && value != null) {
        store == null ? void 0 : store.setValue((prevValue) => {
          if (!Array.isArray(prevValue)) return value;
          if (prevValue.includes(value)) {
            return prevValue.filter((v) => v !== value);
          }
          return [...prevValue, value];
        });
      }
      if (hideOnClickProp(event)) {
        store == null ? void 0 : store.hide();
      }
    });
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _AVNURAH2cjs.SelectItemCheckedContext.Provider, { value: selected != null ? selected : false, children: element }),
      [selected]
    );
    const shouldAutoFocus = (_a = props.autoFocus) != null ? _a : autoFocus;
    props = {
      role: _dom.getPopupItemRole.call(void 0, listElement),
      "aria-selected": selected,
      children: value,
      ...props,
      id,
      // When virtualFocus is false (e.g., iOS Safari), we suppress autoFocus to
      // prevent a re-mounted selected item from stealing focus from the
      // combobox input (which dismisses the iOS keyboard). We keep
      // data-autofocus so the dialog's initial focus effect can still find and
      // focus this element. See https://github.com/ariakit/ariakit/issues/5047
      autoFocus: virtualFocus === false ? false : shouldAutoFocus,
      "data-autofocus": shouldAutoFocus || void 0,
      onClick
    };
    props = _QWIBF3KBcjs.useCompositeItem.call(void 0, {
      store,
      getItem,
      preventScrollOnKeyDown,
      ...props
    });
    const focusOnHoverProp = _3BSDKDKDcjs.useBooleanEvent.call(void 0, focusOnHover);
    props = _ZQYY7DF3cjs.useCompositeHover.call(void 0, {
      store,
      ...props,
      // We have to disable focusOnHover when the popup is closed, otherwise
      // the active item will change to null (the container) when the popup is
      // closed by clicking on an item.
      focusOnHover(event) {
        if (!focusOnHoverProp(event)) return false;
        const state = store == null ? void 0 : store.getState();
        return !!(state == null ? void 0 : state.open);
      }
    });
    return props;
  }
);
var SelectItem = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function SelectItem2(props) {
    const htmlProps = useSelectItem(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);




exports.useSelectItem = useSelectItem; exports.SelectItem = SelectItem;
